import { useState } from "react";
import { vehicles as vApi, formatErr } from "@/lib/api";
import { FilePdf, DownloadSimple, ShareNetwork } from "@phosphor-icons/react";
import { toast } from "sonner";

const isTouch = () => window.matchMedia?.("(pointer: coarse)").matches;

function saveBlob(blob, name) {
  const url = URL.createObjectURL(blob);
  const a = Object.assign(document.createElement("a"), { href: url, download: name });
  document.body.appendChild(a); a.click(); a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 60_000);
}

export default function PdfButtons({ vehicle }) {
  const [busy, setBusy] = useState(null);
  const name = `HaulGuard-${vehicle.vin || "record"}.pdf`;

  const run = async (mode) => {
    // open the tab synchronously so pop-up blockers allow it, then point it at the PDF
    const win = mode === "view" ? window.open("", "_blank") : null;
    setBusy(mode);
    try {
      const blob = await vApi.pdfBlob(vehicle.id);
      if (mode === "share") {
        const file = new File([blob], name, { type: "application/pdf" });
        if (navigator.canShare?.({ files: [file] })) {
          try { await navigator.share({ files: [file], title: name }); } catch { /* share sheet closed */ }
        } else {
          saveBlob(blob, name);
          toast.success("PDF downloaded");
        }
      } else if (mode === "view" && win) {
        win.location.href = URL.createObjectURL(blob);
      } else {
        saveBlob(blob, name);
        toast.success("PDF downloaded");
      }
    } catch (e) {
      if (win) win.close();
      toast.error(formatErr(e));
    } finally {
      setBusy(null);
    }
  };

  if (isTouch()) {
    return <button onClick={() => run("share")} disabled={!!busy} data-testid="btn-pdf" className="btn-dark disabled:opacity-60">
      <ShareNetwork size={18} weight="bold"/> {busy ? "Preparing PDF…" : "Open / save handoff PDF"}
    </button>;
  }
  return <>
    <button onClick={() => run("view")} disabled={!!busy} data-testid="btn-pdf" className="btn-dark disabled:opacity-60">
      <FilePdf size={18} weight="bold"/> {busy === "view" ? "Preparing PDF…" : "View handoff PDF"}
    </button>
    <button onClick={() => run("download")} disabled={!!busy} data-testid="btn-pdf-download" className="btn-dark disabled:opacity-60">
      <DownloadSimple size={18} weight="bold"/> {busy === "download" ? "Preparing PDF…" : "Download PDF"}
    </button>
  </>;
}
